import { postApi } from '../../../../utils/api'
import { getMessageTemplates } from '../../../MessageTemplate'

export function setTextTemplate(id, data) {
  return postApi({
    data,
    endpoint: `api/text-module/message-snippet/${id}/render/`,
  })
}

export function getTextTemplates(search, apiParams) {
  return getMessageTemplates({
    ...apiParams,
    ...(search ? { search } : null),
  })
}
